import {
  FETCH_RECOMMENDATIONS_FAILURE,
  FETCH_RECOMMENDATIONS_REQUEST,
  FETCH_RECOMMENDATIONS_SUCCESS,
  SLIDE_RECOMMENDATION,
} from '../actions/recommendations'

const INITIAL_STATE = {
  isReady: false,
  isFetching: false,
  hasError: false,
  errorMessage: '',
  lastUpdated: -1,
  currentIndex: 0,
  interval: -1,
  recommendations: [],
}

const recommendationsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_RECOMMENDATIONS_REQUEST:
      return {
        ...state,
        isFetching: true,
        hasError: false,
        errorMessage: '',
      }
    case FETCH_RECOMMENDATIONS_SUCCESS:
      return {
        ...state,
        isReady: true,
        isFetching: false,
        lastUpdated: Date.now(),
        currentIndex: 0,
        interval: action.payload.interval,
        recommendations: action.payload.recommendations.map(recommendation => ({
          id: +recommendation.id,
          img: recommendation.cover_image,
          textLarge: recommendation.text_large,
          textSmall: recommendation.text_small,
          textIcon: recommendation.text_icon,
          target: recommendation.action_target,
          targetId: +recommendation.action_id,
        })),
      }
    case FETCH_RECOMMENDATIONS_FAILURE:
      return {
        ...state,
        isReady: true,
        isFetching: false,
        hasError: true,
        errorMessage: action.payload.message,
        lastUpdated: Date.now(),
      }

    case SLIDE_RECOMMENDATION:
      let newIndex = state.currentIndex + 1
      if (newIndex > state.recommendations.length - 1) {
        newIndex = 0
      }
      return {
        ...state,
        currentIndex: newIndex,
      }

    default:
      return state
  }
}

export default recommendationsReducer
